<template>
	<div class="move-user-machine-group">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="$t('moveUserMachineGroup.title')"
			:visible.sync="dialogMoveUserMachineGroup"
			width="860px"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-select
					v-model="moveUserMachine.uId"
					:no-data-text="$t('common.noData')"
					:no-match-text="$t('common.noData')"
					filterable
					class="move-user-machine-group__select"
					:placeholder="$t('moveUserMachineGroup.select')">
					<el-option
						v-for="item in userList"
						:key="item.id"
						:label="item.userName"
						:value="item.id">
						<span style="float: left">{{ item.userName }}</span>
						<span style="float: right; color: #8492a6; font-size: 13px">{{
							item.nickName
						}}</span>
					</el-option>
				</el-select>
				<div class="move-user-machine-group__transfer-wrapper">
					<el-transfer
						class="move-user-machine-group__transfer"
						v-model="moveUserMachine.equipmentIds"
						filterable
						:filter-method="filterMethod"
						:props="{
							key: 'id',
							label: 'equipmentName',
						}"
						:titles="[
							$t('moveUserMachineGroup.titL'),
							$t('moveUserMachineGroup.titR'),
						]"
						:button-texts="[
							$t('moveUserMachineGroup.btL'),
							$t('moveUserMachineGroup.btR'),
						]"
						@change="handleChange"
						:data="machineList">
						<span slot-scope="{ option }"
							>{{ option.equipmentNo }} - {{ option.equipmentName }}</span
						>
					</el-transfer>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="submitForm('userMachineGroup')"
					>{{ $t("moveUserMachineGroup.move") }}</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "MoveUserMachineGroup",
	props: {
		dialogMoveUserMachineGroup: Boolean,
		teamId: String,
	},
	data() {
		return {
			userList: [],
			machineList: [],
			moveUserMachine: {
				equipmentIds: [],
				uId: "",
				teamId: "",
			},
			loadingForm: false,
		};
	},
	methods: {
		normalizeMachineList(data) {
			if (Array.isArray(data)) {
				return data;
			}
			if (data && Array.isArray(data.records)) {
				return data.records;
			}
			return [];
		},
		// 解决穿梭框搜索不出东西bug
		filterMethod(query, item) {
			const keyword = String(query || "").trim();
			return (
				keyword === "" ||
				String(item.id || "").includes(keyword) ||
				String(item.equipmentNo || "").includes(keyword)
			);
		},
		closeDialog() {
			this.cancel("");
		},
		openDialog() {
			this.moveUserMachine.teamId = this.teamId;
			this.$api
				.request(this.$url.UserMachineGroup.choosePage, this.$method.get, {
					teamId: this.teamId,
				})
				.then(res => {
					if (res.code === 0) {
						this.machineList = this.normalizeMachineList(res.data);
					}
				});
			this.$api
				.request(this.$url.UserMachine.listUser, this.$method.get, {
					teamId: this.teamId,
				})
				.then(res => {
					if (res.code === 0) {
						this.userList = res.data;
					}
				});
		},
		submitForm() {
			if (this.moveUserMachine.uId === "") {
				this.$message.warning(this.$t("moveUserMachineGroup.pMoveU"));
				return false;
			}
			if (this.moveUserMachine.equipmentIds.length <= 0) {
				this.$message.warning(this.$t("moveUserMachineGroup.pMoveM"));
				return false;
			}
			this.loadingForm = true;
			this.$api
				.request(
					this.$url.UserMachineGroup.moveUserMachine,
					this.$method.put,
					this.moveUserMachine
				)
				.then(res => {
					let obj = JSON.parse(res.data);
					if (res.code === 0) {
						this.cancel();
						this.$notify({
							title: this.$t("common.tip"),
							message: `number of successes:${obj.success}<br/>number of failures:${obj.error}<br/>${res.msg}`,
							type: "success",
						});
					}
					this.loadingForm = false;
				})
				.catch(() => {
					this.loadingForm = false;
				});
		},
		cancel() {
			this.$emit("moveUserMachineGroupCancel", false);
		},
		handleChange(value, direction, movedKeys) {
		},
	},
};
</script>

<style scoped lang="scss">
.move-user-machine-group__select {
	width: 100%;
}

.move-user-machine-group__transfer-wrapper {
	margin-top: 20px;
	overflow-x: auto;
}

.move-user-machine-group__transfer {
	display: flex !important;
	align-items: center;
	justify-content: center;
	min-width: 700px;
	text-align: left;
}

.move-user-machine-group__transfer ::v-deep .el-transfer-panel {
	width: 300px;
}

.move-user-machine-group__transfer ::v-deep .el-transfer__buttons {
	width: 80px;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0 10px;
}

.move-user-machine-group__transfer ::v-deep .el-transfer__buttons .el-button {
	width: 100%;
	margin-left: 0;
}

.move-user-machine-group__transfer ::v-deep .el-transfer__buttons .el-button:last-child {
	margin-top: 10px;
}

.move-user-machine-group__transfer ::v-deep .el-transfer-panel__filter input {
	border-radius: 4px !important;
}

.move-user-machine-group__transfer ::v-deep .el-transfer-panel__body {
	height: 360px !important;
}

.move-user-machine-group__transfer ::v-deep .el-transfer-panel__list.is-filterable {
	height: 312px;
}
</style>
